(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('complete-the-look')) {
    const COLOR_NAMES = ['color', 'colour', 'couleur', 'farbe'];
    const DESCRIPTION_LENGTH = 220;

    const root = () => window.Shopify?.routes?.root || '/';

    // Adds a width parameter to a Shopify CDN image URL.
    const sized = (url, width) => {
      if (!url) return '';
      const clean = url.startsWith('//') ? `https:${url}` : url;
      return `${clean}${clean.includes('?') ? '&' : '?'}width=${width}`;
    };

    const samePath = (a, b) => a && b && a.split('?')[0].replace(/^https?:/, '') === b.split('?')[0].replace(/^https?:/, '');

    // Formats cents with the store money format (e.g. "${{amount}}").
    const formatMoney = (cents, format) => {
      const value = cents / 100;
      const group = (decimals, thousands, decimal) => {
        const [whole, fraction] = value.toFixed(decimals).split('.');
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
      };
      const patterns = {
        amount: () => group(2, ',', '.'),
        amount_no_decimals: () => group(0, ',', '.'),
        amount_with_comma_separator: () => group(2, '.', ','),
        amount_no_decimals_with_comma_separator: () => group(0, '.', ','),
        amount_with_space_separator: () => group(2, ' ', ','),
        amount_no_decimals_with_space_separator: () => group(0, ' ', ','),
        amount_with_apostrophe_separator: () => group(2, "'", '.'),
      };
      if (!format) return group(2, ',', '.');
      return format
        .replace(/<[^>]*>/g, '')
        .replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (patterns[key] || patterns.amount)());
    };

    const plainText = (html, max) => {
      const text = new DOMParser().parseFromString(html || '', 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
      if (text.length <= max) return text;
      return `${text.slice(0, text.lastIndexOf(' ', max))}...`;
    };

    const el = (tag, className, attrs = {}) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
      return node;
    };

    class CompleteTheLook extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.dialog = this.querySelector('[data-ctl-qv]');
        this.products = new Map();
        this.addEventListener('click', (event) => this.onClick(event));
        this.dialog?.querySelector('[data-qv-track]').addEventListener('scroll', () => this.syncArrows(), { passive: true });
      }

      onClick(event) {
        const target = event.target;
        if (this.dialog?.contains(target)) return this.onDialogClick(event);

        const card = target.closest('[data-ctl-card]');
        if (!card) return;

        const swatch = target.closest('.ctl-swatch');
        if (swatch) return this.selectCardColor(card, swatch);

        const opener = target.closest('[data-ctl-open]');
        if (opener && this.dialog && !(event.metaKey || event.ctrlKey || event.shiftKey)) {
          event.preventDefault();
          return this.openQuickView(card);
        }

        if (target.closest('[data-ctl-add]')) this.onCardAdd(card);
      }

      /* ---------- Card ---------- */

      selectCardColor(card, swatch) {
        card.querySelectorAll('.ctl-swatch').forEach((s) => {
          s.classList.toggle('is-active', s === swatch);
          s.setAttribute('aria-pressed', s === swatch);
        });

        const img = card.querySelector('[data-ctl-main]');
        if (img && swatch.dataset.image) img.src = swatch.dataset.image;

        const name = card.querySelector('[data-ctl-color-name]');
        if (name) name.textContent = swatch.dataset.color;
      }

      // Variants matching the color selected on the card.
      cardVariants(card) {
        card._variants ??= JSON.parse(card.querySelector('[data-ctl-variants]').textContent);
        const colorIndex = Number(card.dataset.colorIndex);
        const color = card.querySelector('.ctl-swatch.is-active')?.dataset.color;
        if (colorIndex < 0 || color == null) return card._variants;
        return card._variants.filter((v) => v.options[colorIndex] === color);
      }

      async onCardAdd(card) {
        if (card.dataset.state === 'loading') return;
        const variants = this.cardVariants(card);

        // Several sizes: let the shopper pick one in the quick view.
        if (variants.length !== 1) {
          if (this.dialog) return this.openQuickView(card);
          window.location.href = card.dataset.url;
          return;
        }

        if (!variants[0].available) return this.flash(card, this.dataset.msgSoldout);

        card.dataset.state = 'loading';
        try {
          await this.addToCart(variants[0].id);
          card.dataset.state = 'added';
          this.flash(card, this.dataset.msgAdded);
          setTimeout(() => card.dataset.state === 'added' && (card.dataset.state = 'idle'), 2000);
          this.openCartDrawer();
        } catch (error) {
          card.dataset.state = 'idle';
          this.flash(card, error.message || this.dataset.msgError);
        }
      }

      flash(card, text) {
        const msg = card.querySelector('[data-ctl-msg]');
        msg.textContent = text;
        clearTimeout(card._msgTimer);
        card._msgTimer = setTimeout(() => (msg.textContent = ''), 3000);
      }

      /* ---------- Quick view ---------- */

      async fetchProduct(handle) {
        if (!this.products.has(handle)) {
          const request = fetch(`${root()}products/${handle}.js`).then((response) => {
            if (!response.ok) throw new Error(this.dataset.msgError);
            return response.json();
          });
          this.products.set(handle, request);
          request.catch(() => this.products.delete(handle));
        }
        return this.products.get(handle);
      }

      async openQuickView(card) {
        const dialog = this.dialog;
        const color = card.querySelector('.ctl-swatch.is-active')?.dataset.color ?? null;

        dialog.querySelector('[data-qv-msg]').textContent = '';
        dialog.dataset.loading = '';
        if (!dialog.open) dialog.showModal();

        try {
          const product = await this.fetchProduct(card.dataset.handle);
          this.renderQuickView(product, color, card.dataset.url);
        } catch (error) {
          dialog.querySelector('[data-qv-msg]').textContent = error.message || this.dataset.msgError;
        } finally {
          delete dialog.dataset.loading;
          dialog.querySelector('[data-qv-close]').focus();
        }
      }

      renderQuickView(product, initialColor, url) {
        const dialog = this.dialog;
        const optionNames = (product.options || []).map((o) => (o.name || o).toLowerCase().trim());
        const colorIndex = optionNames.findIndex((name) => COLOR_NAMES.includes(name));
        const colors = colorIndex < 0 ? [] : [...new Set(product.variants.map((v) => v.options[colorIndex]))];

        this.qv = { product, colorIndex, color: null, variant: null };

        dialog.querySelector('[data-qv-title]').textContent = product.title;
        dialog.querySelector('[data-qv-desc]').textContent = plainText(product.description, DESCRIPTION_LENGTH);
        dialog.querySelector('[data-qv-link]').href = url;

        // Gallery
        const track = dialog.querySelector('[data-qv-track]');
        track.replaceChildren(
          ...product.images.map((src, i) => {
            const slide = el('div', 'ctl-qv__slide');
            const img = el('img', '', {
              src: sized(src, 1200),
              alt: `${product.title} - ${i + 1}`,
              loading: i === 0 ? 'eager' : 'lazy',
            });
            slide.appendChild(img);
            return slide;
          })
        );
        track.scrollLeft = 0;

        // Color swatches
        const colorsWrap = dialog.querySelector('[data-qv-colors-wrap]');
        colorsWrap.hidden = colors.length === 0;
        dialog.querySelector('[data-qv-swatches]').replaceChildren(
          ...colors.map((color) => {
            const variants = product.variants.filter((v) => v.options[colorIndex] === color);
            const image = variants.find((v) => v.featured_image)?.featured_image?.src || product.featured_image;
            const button = el('button', 'ctl-qv__swatch', { type: 'button', 'aria-label': color, title: color });
            button.dataset.qvColor = color;
            if (!variants.some((v) => v.available)) button.classList.add('is-soldout');
            button.appendChild(el('img', '', { src: sized(image, 200), alt: '', loading: 'lazy' }));
            return button;
          })
        );

        const startColor = colors.includes(initialColor) ? initialColor : colors[0] ?? null;
        this.selectQuickViewColor(startColor);
        this.syncArrows();
      }

      selectQuickViewColor(color) {
        const { product, colorIndex } = this.qv;
        const dialog = this.dialog;
        this.qv.color = color;
        this.qv.variant = null;

        dialog.querySelectorAll('[data-qv-color]').forEach((swatch) => {
          const active = swatch.dataset.qvColor === color;
          swatch.classList.toggle('is-active', active);
          swatch.setAttribute('aria-pressed', active);
        });
        dialog.querySelector('[data-qv-color-name]').textContent = color || '';

        const variants = colorIndex < 0 ? product.variants : product.variants.filter((v) => v.options[colorIndex] === color);

        // Size buttons (every option except color)
        const sizes = dialog.querySelector('[data-qv-sizes]');
        sizes.classList.remove('is-required');
        if (variants.length === 1) {
          this.qv.variant = variants[0];
          sizes.replaceChildren();
        } else {
          sizes.replaceChildren(
            ...variants.map((variant) => {
              const button = el('button', 'ctl-qv__size', { type: 'button' });
              button.dataset.qvVariant = variant.id;
              button.disabled = !variant.available;
              button.textContent = variant.options.filter((_, i) => i !== colorIndex).join(' / ');
              return button;
            })
          );
        }

        this.renderPrice(this.qv.variant || variants[0]);
        this.updateAddButton();

        // Jump the gallery to this color's image
        const image = variants.find((v) => v.featured_image)?.featured_image?.src;
        const index = product.images.findIndex((src) => samePath(src, image));
        if (index > 0) {
          const track = dialog.querySelector('[data-qv-track]');
          track.scrollTo({ left: track.clientWidth * index });
        }
      }

      selectQuickViewSize(id) {
        const variant = this.qv.product.variants.find((v) => v.id === id);
        if (!variant) return;
        this.qv.variant = variant;

        this.dialog.querySelectorAll('[data-qv-variant]').forEach((button) => {
          button.classList.toggle('is-active', Number(button.dataset.qvVariant) === id);
          button.setAttribute('aria-pressed', Number(button.dataset.qvVariant) === id);
        });
        this.dialog.querySelector('[data-qv-sizes]').classList.remove('is-required');

        this.renderPrice(variant);
        this.updateAddButton();
      }

      renderPrice(variant) {
        const price = this.dialog.querySelector('[data-qv-price]');
        price.replaceChildren();
        if (!variant) return;

        const current = el('span');
        current.textContent = formatMoney(variant.price, this.dataset.moneyFormat);
        price.appendChild(current);

        if (variant.compare_at_price > variant.price) {
          const compare = el('s');
          compare.textContent = formatMoney(variant.compare_at_price, this.dataset.moneyFormat);
          price.appendChild(compare);
        }
      }

      updateAddButton() {
        const button = this.dialog.querySelector('[data-qv-add]');
        const label = this.dialog.querySelector('[data-qv-add-label]');
        const { variant } = this.qv;

        if (!variant) {
          button.disabled = false;
          label.textContent = this.dataset.msgChooseSize;
        } else if (!variant.available) {
          button.disabled = true;
          label.textContent = this.dataset.msgSoldout;
        } else {
          button.disabled = false;
          label.textContent = this.dataset.msgAdd;
        }
      }

      async onDialogClick(event) {
        const target = event.target;
        const dialog = this.dialog;

        // Close on the X button or on a click outside the panel (backdrop)
        if (target === dialog || target.closest('[data-qv-close]')) return dialog.close();

        const track = dialog.querySelector('[data-qv-track]');
        if (target.closest('[data-qv-prev]')) return track.scrollBy({ left: -track.clientWidth });
        if (target.closest('[data-qv-next]')) return track.scrollBy({ left: track.clientWidth });

        const swatch = target.closest('[data-qv-color]');
        if (swatch) return this.selectQuickViewColor(swatch.dataset.qvColor);

        const size = target.closest('[data-qv-variant]');
        if (size) return this.selectQuickViewSize(Number(size.dataset.qvVariant));

        const add = target.closest('[data-qv-add]');
        if (!add || add.hasAttribute('data-loading')) return;

        if (!this.qv?.variant) {
          const sizes = dialog.querySelector('[data-qv-sizes]');
          sizes.classList.remove('is-required');
          void sizes.offsetWidth; // restart the shake animation
          sizes.classList.add('is-required');
          return;
        }

        add.setAttribute('data-loading', '');
        try {
          await this.addToCart(this.qv.variant.id);
          dialog.close();
          this.openCartDrawer();
        } catch (error) {
          dialog.querySelector('[data-qv-msg]').textContent = error.message || this.dataset.msgError;
        } finally {
          add.removeAttribute('data-loading');
        }
      }

      syncArrows() {
        const track = this.dialog.querySelector('[data-qv-track]');
        const prev = this.dialog.querySelector('[data-qv-prev]');
        const next = this.dialog.querySelector('[data-qv-next]');
        const scrollable = track.scrollWidth - track.clientWidth > 4;

        prev.hidden = !scrollable;
        next.hidden = !scrollable;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      /* ---------- Cart ---------- */

      async addToCart(id) {
        // Horizon cart sections to refresh (drawer + cart page)
        const sectionIds = [
          ...new Set(
            [...document.querySelectorAll('cart-items-component[data-section-id]')].map((node) => node.dataset.sectionId)
          ),
        ];

        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id, quantity: 1 }],
            ...(sectionIds.length && { sections: sectionIds.join(',') }),
          }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.msgError);

        const cart = await (await fetch(`${root()}cart.js`)).json();

        // Event Horizon listens to for the cart icon count and the drawer
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'complete-the-look',
              data: { source: 'complete-the-look', itemCount: cart.item_count, sections: result.sections },
            },
          })
        );

        return cart;
      }

      openCartDrawer() {
        document.querySelector('cart-drawer-component')?.open?.();
      }
    }

    customElements.define('complete-the-look', CompleteTheLook);
  }
  } catch(e) { console.error(e); }
})();

})();
